import { useEffect, useState, type ImgHTMLAttributes } from "react";
import styles from "./BancoImage.module.css";

interface BancoImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src"> {
  src?: string | null;
  fallbackClassName?: string;
}

function PlaceholderIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 320 240" fill="none" aria-hidden="true">
      <rect x="68" y="56" width="184" height="128" rx="20" stroke="currentColor" strokeWidth="10" />
      <circle cx="114" cy="98" r="16" stroke="currentColor" strokeWidth="10" />
      <path d="M78 178 126 130 152 156 196 102l48 76" stroke="currentColor" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function BancoImage({
  src,
  alt = "Imagem",
  className,
  fallbackClassName,
  onError,
  ...props
}: BancoImageProps) {
  const [falhou, setFalhou] = useState(false);
  const possuiSrc = Boolean(String(src || "").trim());

  useEffect(() => {
    setFalhou(false);
  }, [src]);

  if (possuiSrc && !falhou) {
    return (
      <img
        {...props}
        src={String(src)}
        alt={alt}
        className={className}
        onError={(event) => {
          setFalhou(true);
          onError?.(event);
        }}
      />
    );
  }

  return (
    <span
      className={[styles.fallback, className, fallbackClassName].filter(Boolean).join(" ")}
      role="img"
      aria-label={alt}
    >
      <PlaceholderIcon className={styles.icon} />
    </span>
  );
}
